import { DropdownModule } from 'primeng/dropdown';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { SharedModule } from 'src/app/_theme/components/shared.module';
import { AppSharedModule } from 'src/app/_shared/app-shared.module';
import { QueryComponent } from './query.component';
import { OptionsComponent } from './options/options.component';
import { DataGridComponent } from './data-grid/data-grid.component';
import { ScenariosComponent } from './scenarios/scenarios.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ArgumentComponent } from './argument/argument.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { TabViewModule} from 'primeng/tabview';

import { MultiSelectModule} from 'primeng/multiselect';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { QuerysetComponent } from './queryset/queryset.component';
import { StoreModule } from '@ngrx/store';
import { splitPageQueryReducer, processQueryReducer, queryReducer } from './query.reducer';
import { SubqueryComponent } from './subquery/subquery.component';
import { TableModule } from 'primeng/table';
import { SidebarModule } from 'primeng/sidebar';
import {DialogModule} from 'primeng/dialog';
import { ColorPickerModule } from "primeng/colorpicker";
import { GraphicComponent } from './graphic/graphic.component';
import { GraphicPanelComponent } from './graphic-panel/graphic-panel.component';

const routes: Routes = [
  {
    path: ':optionmenu/:queryid/:basedonid',
    component: QuerysetComponent
  },
  {
    path: 'subquery/:queryid/:basedonid/:queryColumnId/:value/:queryHeader/:basedOnHeaderId',
    component: SubqueryComponent
  }
];

@NgModule({
  declarations: [
    QueryComponent,
    OptionsComponent,
    DataGridComponent,
    ScenariosComponent,
    ArgumentComponent,
    QuerysetComponent,
    SubqueryComponent,
    GraphicComponent,
    GraphicPanelComponent,
  ],
  imports: [
    CommonModule,
    StoreModule.forFeature("splitPageQueryState", splitPageQueryReducer),
    StoreModule.forFeature("processQueryState", processQueryReducer),
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    SharedModule,
    AppSharedModule,
    PerfectScrollbarModule,
    ModalModule,
    // BrowserAnimationsModule,/// debe aparecer una sola vez
    CalendarModule,
    TabViewModule,
    DropdownModule,
    MultiSelectModule,
    InputTextareaModule,
    TableModule,
    SidebarModule,
    DialogModule,
    ColorPickerModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class QueryModule {}
